"use strict";
/**
 * Created by Marvin on 02.05.17.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var modalActions_1 = require("../actions/modalActions");
var ModalCloseButton_1 = __importDefault(require("./ModalCloseButton"));
var ModalHeader = function (_a) {
    var children = _a.children, hide = _a.hide, props = __rest(_a, ["children", "hide"]);
    return (react_1["default"].createElement("div", { className: "modal-header" },
        (props.hideClose) ? '' :
            (react_1["default"].createElement(ModalCloseButton_1["default"], null)),
        children));
};
var mapDispatchToProps = function (dispatch) { return ({
    hide: function () { return dispatch((0, modalActions_1.hideModal)()); }
}); };
exports["default"] = (0, react_redux_1.connect)(null, mapDispatchToProps)(ModalHeader);
